import { render, staticRenderFns } from "./transactions_history.vue?vue&type=template&id=298e1efa"
import script from "./transactions_history.vue?vue&type=script&lang=js"
export * from "./transactions_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports